import config from '../../config/local-config'

const formatBrand = brand => {
    const trademarkBrand =
        typeof brand === "string" && !config.removeTrademarkBrands.includes(brand)
    return trademarkBrand ? `${brand}®` : `${brand}`
}

const formatBrandInText = (text, brand = '') => {
    let textStr = ''

    if (typeof text === "string" && brand === '') { // Meta title, description and Reviews
        const textArr = config.removeTrademarkBrands.map(brnd => text.includes(brnd) && text.replace(brnd+'®', brnd))
        textStr = textArr.filter(val => val !== false).toString() || text
    } else if (typeof brand === "string" && config.removeTrademarkBrands.includes(brand)) { // PDP Description
        const regxBrand = new RegExp(brand+'&reg;', 'gi')
        textStr = text.replace(regxBrand, brand)
    } else {
        textStr = text
    }

    return textStr
}

export {
    formatBrand,
    formatBrandInText
}